var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Welcome_to_Glue",
    "data-name": "Welcome to Glue",
    d: "M13.748,6.861a12.075,12.075,0,0,0,12-12,12.085,12.085,0,0,0-12.012-12,12.073,12.073,0,0,0-11.988,12A12.075,12.075,0,0,0,13.748,6.861ZM12.459.6a1.376,1.376,0,0,1-1.127-.616L8.486-3.477A1.286,1.286,0,0,1,8.172-4.3a1.068,1.068,0,0,1,1.069-1.08,1.1,1.1,0,0,1,.929.511l2.242,2.846,4.809-7.69a1.086,1.086,0,0,1,.941-.6,1.048,1.048,0,0,1,1.1,1.011,1.63,1.63,0,0,1-.3.813L13.527-.016A1.276,1.276,0,0,1,12.459.6Z",
    transform: "translate(-1.748 17.139)",
    fill: "#67cf89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscriptionIcon.79246feb3d1d60fed164c0592a810fc5.svg";
export { ForwardRef as ReactComponent };